import {Component, OnInit} from '@angular/core';
import {firstValueFrom, lastValueFrom} from 'rxjs';
import {TranslateModule, TranslateService} from '@ngx-translate/core';
import {CommonModule} from '@angular/common';
import {UpdateAccountRequest} from '../../../models/update-account-requests';
import {ApiAgentService} from '../../../services/api-agent.service';
import {GlobalLoaderService} from '../../../services/global-loader.service';
import {EnvironmentService} from '../../../services/environment.service';
import {FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, ValidationErrors, Validators} from '@angular/forms';
import {UpdateAccountInitInfo} from '../../../models/update-account-init-info';
import {RouterModule} from '@angular/router';

declare var $: any;

@Component({
  selector: 'app-request-update-account',
  templateUrl: './request-update-account.component.html',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, TranslateModule, RouterModule],
  styleUrls: ['./request-update-account.component.scss']
})
export class RequestUpdateAccountComponent implements OnInit {
  submitting: any;
  submitted: any;
  loading: any;
  currentLang: any;
  isAccountant: boolean;
  isManager: boolean;
  isSales: boolean;
  isMerchant: boolean;
  accountUpdateRequests: UpdateAccountRequest[];
  myBusiness: UpdateAccountInitInfo;
  updateAccountForm: FormGroup;
  viewAccountForm: FormGroup;
  sendAccountOtpForm: FormGroup;
  nafathRandomNumber: any;
  nafathStatus: any;
  requestId: any;
  daysOfMonth: string[];
  monthsNames: string[];
  licenseType: any;
  freelancerFile: any;

  // myBusiness: MyBusiness;

  constructor(protected translate: TranslateService, private formBuilder: FormBuilder,
              private loader: GlobalLoaderService,
              private api: ApiAgentService, private env: EnvironmentService) {
  }

  async ngOnInit() {
    this.loading = true;
    this.updateAccountForm = this.formBuilder.group({
      iban: ['', [Validators.required, Validators.maxLength(24)]],
      bank: ['', [Validators.required, Validators.maxLength(50)]],
      licenseNumber: ['', [Validators.required, Validators.maxLength(100)]],
      licenseName: ['', [Validators.required, Validators.maxLength(100)]],
      licenseType: ['', [Validators.required, Validators.maxLength(15)]],
      mobile: ['', [Validators.required, Validators.maxLength(15)]],
      // identityExpiry: ['', [Validators.required, Validators.maxLength(15)]],
      salesVolume: ['', [Validators.required, Validators.maxLength(20)]],
      email: ['', [Validators.required, Validators.email]],
      sellingScope: ['', [Validators.required, Validators.maxLength(10)]],
      globalReason: ['', [Validators.maxLength(1000)]],
      hijriBirthDay: ['', [Validators.required, Validators.maxLength(2)]],
      hijriBirthMonth: ['', [Validators.required, Validators.maxLength(2)]],
      hijriBirthYear: ['', [Validators.required, Validators.maxLength(4)]],
      identityNumber: ['', [Validators.required, Validators.maxLength(10)]]
    });

    this.viewAccountForm = this.formBuilder.group({
      iban: ['', [Validators.required, Validators.maxLength(24)]],
      bank: ['', [Validators.required, Validators.maxLength(50)]],
      licenseNumber: ['', [Validators.required, Validators.maxLength(15)]],
      licenseName: ['', [Validators.required, Validators.maxLength(100)]],
      licenseType: ['', [Validators.required, Validators.maxLength(15)]],
      mobile: ['', [Validators.required, Validators.maxLength(15)]],
      // identityExpiry: ['', [Validators.required, Validators.maxLength(15)]],
      salesVolume: ['', [Validators.required, Validators.maxLength(20)]],
      email: ['', [Validators.required, Validators.email]],
      sellingScope: ['', [Validators.required, Validators.maxLength(10)]],
      globalReason: ['', [Validators.maxLength(1000)]],
      hijriBirthDate: ['', [Validators.required, Validators.maxLength(15)]],
      identityNumber: ['', [Validators.required, Validators.maxLength(10)]],
      rejectSolution: [''],
      rejectReason: ['']
    });

    this.sendAccountOtpForm = this.formBuilder.group({
      otp: ['', [Validators.required, Validators.maxLength(10)]]
    });

    console.log('init');
    setTimeout(async () => {
      await this.loadResources();
      console.log('loaded resources');
      await this.loadData();
      console.log('loaded data');

      setTimeout(async () => {
        // noinspection JSJQueryEfficiency
        let object = $('#update-accounts-requests-table').DataTable;
        while (!object) {
          object = $('#update-accounts-requests-table').DataTable;
        }
        await this.loadTable();
        console.log('loaded table');
        this.loading = false;
        this.currentLang = await firstValueFrom(this.translate.get('ltr')) == 'rtl' ? 'ar' : 'en';
        console.log('current lang', this.currentLang);
        this.buildDate();

      }, 1000);
    }, 1000);
  }

  buildDate() {
    this.daysOfMonth = [];
    for (let i = 0; i < 30; i++) {
      let day = i + 1;
      this.daysOfMonth.push(day + '');
    }

    this.monthsNames = [];
    this.monthsNames.push('1 - Muharram محرم');
    this.monthsNames.push('2 - Safar صفر');
    this.monthsNames.push('3 - Rabee AlAwwal ربيع الاول');
    this.monthsNames.push('4 - Rabee AlAkher ربيع الآخر');
    this.monthsNames.push('5 - Jamad AlAwwal جمادى الاول');
    this.monthsNames.push('6 - Jamad AlThani جمادى الثاني');
    this.monthsNames.push('7 - Rajab رجب');
    this.monthsNames.push('8 - Shabaan شعبان');
    this.monthsNames.push('9 - Ramadan رمضان');
    this.monthsNames.push('10 - Shawwal شوال');
    this.monthsNames.push('11 - Dhu AlQedah ذو القعدة');
    this.monthsNames.push('12 - Dhu AlHejja ذو الحجة');
  }

  async loadData(): Promise<void> {
    try {
      this.myBusiness = await this.api.getUpdateAccountInitInfo();
      this.accountUpdateRequests = await this.api.getAccountUpdates();
      console.log('loaded data', this.accountUpdateRequests);
    } catch (error) {
      console.error('Error fetching data:', error);
      // You might want to handle the error better, e.g., show a notification to the user.
      alert(`Error fetching data: ${error.message || error}`);
    }
  }

  // @ts-ignore
  get f() {
    return this.updateAccountForm.controls;
  }

  // @ts-ignore
  get ff() {
    return this.sendAccountOtpForm.controls;
  }

  async submitForm() {
    debugger;
    this.submitted = true;
    if (this.updateAccountForm.valid) {

      let hijriDate = this.f['hijriBirthYear'].value + '-' + ('' + (parseInt(this.f['hijriBirthMonth'].value) + 1)) + '-' + this.f['hijriBirthDay'].value;

      let payload = {
        iban: this.f['iban'].value,
        bank: this.f['bank'].value,
        licenseNumber: this.f['licenseNumber'].value,
        licenseName: this.f['licenseName'].value,
        licenseType: this.f['licenseType'].value,
        mobile: this.f['mobile'].value,
        // identityExpiry: this.f['identityExpiry'].value,
        salesVolume: this.f['salesVolume'].value,
        email: this.f['email'].value,
        sellingScope: this.f['sellingScope'].value,
        globalReason: this.f['globalReason'].value,
        hijriBirthDate: hijriDate,
        identityNumber: this.f['identityNumber'].value
      };

      if (this.myBusiness.licenseType == 'freelancer') {
        const fileResponse = await this.api.uploadFileToServer(this.freelancerFile);
        console.log('fileResponse', fileResponse);
        payload.licenseNumber = fileResponse.licenseNumber;
      }

      try {
        this.submitting = true;
        let saved = await this.api.saveAccountUpdate(payload);
        if (saved.id) {
          this.requestId = saved.id;
          this.submitted = false;
        }
      } catch (error) {
        this.handleServerError(error);
      } finally {
        this.submitting = false;
      }
    }
  }

  async submitOtpForm() {
    debugger;
    console.log('submit otp form');
    this.submitted = true;
    if (this.sendAccountOtpForm.valid) {
      let payload = {
        otp: this.ff['otp'].value,
        requestId: this.requestId
      };

      try {
        this.submitting = true;
        let saved = await this.api.saveAccountUpdateOtp(payload);
        if (saved.requestId) {
          this.nafathRandomNumber = saved.nafathRandomNumber;
          this.checkOtpForm();
        }
      } catch (error) {
        this.handleServerError(error);
      } finally {
        this.submitting = false;
      }
    } else {
      console.error('error', this.sendAccountOtpForm.errors);
    }
  }

  checkOtpForm() {
    let payload = {
      requestId: this.requestId
    };

    let interval = setInterval(async () => {
      try {
        this.nafathStatus = 'PENDING';
        let saved = await this.api.checkAccountUpdateOtp(payload);
        if (saved.nafathStatus) {
          this.nafathStatus = saved.nafathStatus;
          if (this.nafathStatus == 'COMPLETED') {
            clearInterval(interval);
            setTimeout(() => {
              window.location.reload();
            }, 4000);
          }
        }
      } catch (error) {
        this.handleServerError(error);
      }
    }, 5000);
  }

  openModal(): void {
    $('#updateAccountFormModal').modal('show');


    let [year, month, day] = ['', '', ''];
    if (this.myBusiness.hijriBirthDate != null) {
      [year, month, day] = this.myBusiness.hijriBirthDate.split('-');
      console.log('splitting hijri dates');
    }

    setTimeout(() => {
      console.log('init info', this.myBusiness);
      console.log('year', year);
      console.log('month', month);
      console.log('day', day);

      for (let l of this.myBusiness.licenseTypes) {
        if (l.key == this.myBusiness.licenseType) {
          this.licenseType = l;
          break;
        }
      }

      this.updateAccountForm.patchValue({
        iban: this.myBusiness.iban,
        bank: this.myBusiness.bank,
        licenseName: this.myBusiness.licenseName,
        licenseType: this.myBusiness.licenseType,
        mobile: this.myBusiness.mobile,
        salesVolume: this.myBusiness.salesVolume,
        email: this.myBusiness.email,
        sellingScope: this.myBusiness.sellingScope,
        globalReason: this.myBusiness.globalReason,
        hijriBirthDay: day,
        hijriBirthMonth: parseInt(month) - 1,
        hijriBirthYear: year,
        identityNumber: this.myBusiness.identityNumber
      });
      if (this.myBusiness.licenseType != 'freelancer') {
        this.updateAccountForm.patchValue({
          licenseNumber: this.myBusiness.licenseNumber
        });
      }
    }, 500);

  }

  checkPermission() {
    let perms = this.env.checkPermission(this.myBusiness.subAccountType, this.myBusiness.subAccountGovId);
    this.isAccountant = perms.isAccountant;
    this.isSales = perms.isSales;
    this.isManager = perms.isManager;
    this.isMerchant = perms.isMerchant;
  }

  private async loadResources() {
    await this.loader.loadExternalStyles('https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.4/css/all.min.css');
    await this.loader.loadExternalStyles('/plugins/table/datatable/custom_dt_html5.css');
    await this.loader.loadExternalStyles('/plugins/table/datatable/dt-global_style.css');
    await this.loader.loadExternalScript('https://cdn.datatables.net/1.12.1/js/jquery.dataTables.js');
    await this.loader.loadExternalScript('/plugins/table/datatable/button-ext/dataTables.buttons.min.js');
    await this.loader.loadExternalScript('/plugins/table/datatable/button-ext/jszip.min.js');
    await this.loader.loadExternalScript('/plugins/table/datatable/button-ext/buttons.html5.min.js');
    await this.loader.loadExternalScript('/plugins/table/datatable/button-ext/buttons.print.min.js');
    await this.loader.loadExternalScript('plugins/apex/apexcharts.min.js');
  }

  cancelRequest(id: any) {
    $('#requestNumber').text(id);
    $('#cancelModal .btn-primary').on('click', async () => {
      await this.handleCancelResponse('yes', id);
    });

    $('#cancelModal .btn-secondary').on('click', async () => {
      await this.handleCancelResponse('no', id);
    });
    $('#cancelModal').modal('show');
  }

  viewRequest(id: any) {
    console.log('id sent is', id);
    let requests = this.accountUpdateRequests.filter(value => value.id == id);
    console.log('requests', requests);
    let req = null;
    if (requests.length > 0) {
      req = requests[0];
    }

    console.log('req', req);

    if (req != null) {
      $('#viewAccountFormModal').modal('show');

      setTimeout(() => {
        this.viewAccountForm.patchValue({
          iban: req.iban,
          bank: req.bank,
          licenseNumber: req.licenseNumber,
          licenseName: req.licenseName,
          licenseType: req.licenseType,
          mobile: req.mobile,
          // identityExpiry: req.identityExpiry,
          salesVolume: req.salesVolume,
          email: req.email,
          sellingScope: req.sellingScope,
          globalReason: req.globalReason,
          hijriBirthDate: req.hijriBirthDate,
          identityNumber: req.identityNumber,
          rejectSolution: req.rejectSolution,
          rejectReason: req.rejectReason
        });
      }, 500);
    }

  }

  async handleCancelResponse(answer: any, id: any) {
    if (answer === 'yes') {
      $('#cancelModal').modal('hide');
      try {
        await this.api.cancelAccountUpdate(id);
        window.location.reload();
      } catch (error) {
        this.handleServerError(error);
      }
    } else if (answer === 'no') {
      $('#cancelModal').modal('hide');
    }
  }

  async loadTable() {
    let Cancelled = await firstValueFrom(this.translate.get('Cancelled'));
    let Draft = await firstValueFrom(this.translate.get('Draft'));
    let Approved = await firstValueFrom(this.translate.get('Approved'));
    let Rejected = await firstValueFrom(this.translate.get('Rejected'));
    let Pending = await firstValueFrom(this.translate.get('Pending Approval'));

    let tableButtons = [];
    $('#update-accounts-requests-table').DataTable({
      dom: '<"row"<"col-md-12"<"row"<"col-md-6"B><"col-md-6"f> > ><"col-md-12"rt> <"col-md-12"<"row"<"col-md-5"i><"col-md-7"p>>> >',
      buttons: {
        buttons: tableButtons
      },
      'oLanguage': {
        'oPaginate': {
          'sPrevious': '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-arrow-right"><line x1="5" y1="12" x2="19" y2="12"></line><polyline points="12 5 19 12 12 19"></polyline></svg>',
          'sNext': '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-arrow-left"><line x1="19" y1="12" x2="5" y2="12"></line><polyline points="12 19 5 12 12 5"></polyline></svg>'
        },
        'sInfo': await lastValueFrom(this.translate.get('Showing page')) + ' _PAGE_ ' + await lastValueFrom(this.translate.get('of')) + ' _PAGES_',
        'sLengthMenu': 'Results :  _MENU_',
      },
      'stripeClasses': [],
      'pageLength': 10,
      'lengthMenu': [7, 10, 20, 50],
      'data': this.accountUpdateRequests,
      'bFilter': false,  // This hides the search box
      'columns': [
        {'data': 'id'},
        {
          'data': null, 'render': (data: any) => {
            let id = data.id;
            if (data.submissionStatus == 'Draft' || data.submissionStatus == 'Pending') {
              return '<a class="btn-cancel"><i class="text-danger fas fa-trash"></i></a>';
            } else if (data.submissionStatus == 'Rejected' || data.submissionStatus == 'Approved') {
              return '<a class="btn-view" data-id="' + id + '" ><i class="text-primary fas fa-eye"></i></a>';
            } else {
              return '<i class="text-dark fas fa-trash"></i>';
            }
          }
        },
        {
          'data': 'submissionStatus', 'render': (data: any) => {
            switch (data) {
              case 'Cancelled':
                return '<span class="text-warning">' + Cancelled + '</span>';
              case 'Draft':
                return Draft;
              case 'Approved':
                return '<span class="text-success">' + Approved + '</span>';
              case 'Rejected':
                return '<span class="text-danger">' + Rejected + '</span>';
              case 'Pending':
                return '<span class="text-primary ">' + Pending + '</span>';
            }
          }
        },
        {'data': 'iban'},
        {'data': 'bank'},
        {'data': 'licenseNumber'},
        {'data': 'licenseName'},
        {'data': 'licenseType'},
        {'data': 'mobile'},
        // {'data': 'identityExpiry'},
        {'data': 'salesVolume'},
        {'data': 'email'},
        {'data': 'sellingScope'},
        {'data': 'globalReason'},
        {'data': 'hijriBirthDate'},
        {'data': 'identityNumber'},
      ]
    });

    let self = this;

    // noinspection JSJQueryEfficiency
    $('#update-accounts-requests-table tbody').on('click', '.btn-cancel', function() {
      let row = $(this).parents('tr');
      let data = $('#update-accounts-requests-table').DataTable().row(row).data();
      self.cancelRequest(data.id + '');
    }).bind();

    // noinspection JSJQueryEfficiency
    $('#update-accounts-requests-table tbody').on('click', '.btn-view', function() {
      let row = $(this).parents('tr');
      let data = $('#update-accounts-requests-table').DataTable().row(row).data();
      console.log('data = ', data);
      self.viewRequest(data.id + '');
    }).bind();
  }

  getFormErrors(formGroup: FormGroup): string[] {
    const errors: string[] = [];
    Object.keys(formGroup.controls).forEach(key => {
      // @ts-ignore
      // debugger;
      let formControl = formGroup.controls[key];
      if (formControl == null) {
        return;
      }
      const controlErrors: ValidationErrors = formControl.errors;
      if (controlErrors != null) {
        Object.keys(controlErrors).forEach(keyError => {
          let ctrl = this.mapKey(key);
          if (ctrl == null) {
            ctrl = key;
          }
          errors.push(`${ctrl} is ${keyError}`);
        });
      }
    });
    return errors;
  }

  markError(key: any) {
    if (this.submitted) {
      $('#' + key).css('border', '1px solid red');
    }
  }

  mapKey(key: any) {
    this.markError(key);
    switch (key) {
      case 'iban':
        return 'IBAN';
      case 'bank':
        return 'Bank';
      case 'licenseNumber':
        return 'License Number';
      case 'licenseName':
        return 'License Name';
      case 'licenseType':
        return 'License Type';
      case 'mobile':
        return 'Mobile';
      // case 'identityExpiry':
      //   return 'Identity Expiry';
      case 'salesVolume':
        return 'Sales Volume';
      case 'email':
        return 'Email';
      case 'sellingScope':
        return 'Selling Scope';
      case 'globalReason':
        return 'Global Reason';
      case 'hijriBirthDate':
        return 'Hijri Birth Date';
      case 'identityNumber':
        return 'Identity Number';
    }
  }

  handleFileChange(event: any) {
    const input = event.target as HTMLInputElement;
    const files = input.files;
    // Check if a file is selected
    if (files[0]) {
      const file = files[0];
      // Ensure the selected file is a PDF
      if (file.type !== 'application/pdf') {
        alert('Only PDF files are allowed!');
        return;
      }
      this.freelancerFile = file;
    }
  }

  dismissForm() {
    $('#updateAccountFormModal').modal('hide');
    $('#viewAccountFormModal').modal('hide');
    this.requestId = null;
    this.nafathStatus = null;
    this.nafathRandomNumber = null;
    this.sendAccountOtpForm.reset();
  }

  private handleServerError(error: any) {
    console.log('error is', error);
    let errorMessage = 'An error occurred while cancelling the account update. Please try again.';
    if (error.status) {
      errorMessage += `\nHTTP Status Code: ${error.status}`;
    }
    if (error.message) {
      errorMessage += `\nError Message: ${error.message}`;
    }
    if (error.error && error.error.message) {
      errorMessage += `\nServer Error Message: ${error.error.message}`;
    }

    if (error.error && error.error.detail) {
      errorMessage = `${error.error.detail}`;
    }
    if (error.detail) {
      errorMessage = error.detail;
    }
    if (typeof error === 'string') {
      try {
        const errorObj = JSON.parse(error);
        if (errorObj.detail) {
          errorMessage = errorObj.detail;
        } else {
          errorMessage = error;
        }
      } catch (e) {
      }
    }

    alert(errorMessage);
  }
}
